import(/* webpackMode: "eager", webpackExports: ["DebugPanelLoader"] */ "/app/apps/web/src/app/components/debug-panel/DebugPanelLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeftSidebar"] */ "/app/apps/web/src/app/components/doc/left-sidebar/LeftSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileFooter"] */ "/app/apps/web/src/app/components/doc/mobile-footer/MobileFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileHeader"] */ "/app/apps/web/src/app/components/doc/mobile-header/MobileHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/web/src/app/utils/ThemeProvider.tsx");
